import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { LANGUAGE } from "./constants/global";
import de from "./locales/de/translation.json";
import en from "./locales/en/translation.json";
import hu from "./locales/hu/translation.json";
import pl from "./locales/pl/translation.json";
import sk from "./locales/sk/translation.json";
import { getItem } from "./utils/storage";

const storedLanguage = getItem(LANGUAGE) ?? "sk";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    sk: { translation: sk },
    de: { translation: de },
    hu: { translation: hu },
    pl: { translation: pl }
  },
  lng: storedLanguage,
  fallbackLng: "sk",
  keySeparator: false,
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
